import { useState } from "react";
import { careEnvironment, getQueryClient } from "@akina/config";
import { loggerService, IntlProvider } from "@akina/infra";
import {
  useLocaleCopyStore,
  useLocaleStore,
  ErrorBoundary,
  LocaleBootstrapper,
  Toaster,
} from "@akina/presentation";
import { flattenMessages } from "@akina/utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { Providers } from "./Providers";

export function AppProvider() {
  const { locale } = useLocaleStore();
  const { localeCopy } = useLocaleCopyStore();

  const messages = flattenMessages(localeCopy);
  const [queryClient] = useState(() =>
    getQueryClient({
      log: loggerService.info,
    }),
  );

  return (
    <ErrorBoundary env={careEnvironment.environment}>
      <IntlProvider onError={() => null} locale={locale} messages={messages}>
        <QueryClientProvider client={queryClient}>
          <LocaleBootstrapper slugPrefixes={["care", "shared"]} />
            <Toaster />
            <Providers />
        </QueryClientProvider>
      </IntlProvider>
    </ErrorBoundary>
  );
}
